import * as Yup from 'yup';

export const EditAccountValidationSchema = () => {
    return Yup.object({
        name: Yup.string().required("O nome de utilizador é obrigatório")
    });
}